import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate, Outlet } from "react-router-dom";

export const messagingRoutes: PermissionedRouteObject[] = [
  {
    element: <Outlet />,
    children: [
      { index: true, element: <Navigate replace to="pre-purchase" /> },
      {
        path: "conversations",
        element: <Outlet />,
        children: [
          {
            index: true,
            async lazy() {
              const { ConversationsListPage } = await import(
                "../../../messaging/conversations/conversations-list-page"
              );
              return { Component: ConversationsListPage };
            },
          },
          {
            path: ":conversationId",
            async lazy() {
              const { ConversationDetailPage } = await import(
                "../../../messaging/conversations/conversation-detail-page"
              );
              return { Component: ConversationDetailPage };
            },
          },
        ],
      },
      {
        path: "pre-purchase",
        async lazy() {
          const { PrePurchaseConfigPage } = await import(
            "../../../messaging/pre-purchase-config-page"
          );
          return { Component: PrePurchaseConfigPage };
        },
      },
      {
        path: "post-purchase",
        async lazy() {
          const { PostPurchaseConfigPage } = await import(
            "../../../messaging/post-purchase-config-page"
          );
          return { Component: PostPurchaseConfigPage };
        },
      },
    ],
  },
];
